module.exports = __webpack_public_path__ + "static/owlbear-8d009464ff2de973a6f3eb9546af6e97.jpg";